import './lib-entry'
;(function () {
  window.addEventListener('load', () => {
    const assistant_tag = document.getElementById('emir@ai')
    console.log('client-key:', assistant_tag?.dataset.clientKey)
    const script_src = assistant_tag?.getAttribute('src')
    let base_url = './'
    if (script_src) {
      const end = script_src.indexOf('ai-widget.umd.js')
      base_url = script_src.substring(0, end - 1)
    }

    // Load styles
    const style = document.createElement('link')
    style.href = `${base_url}/style.css`
    style.rel = 'stylesheet'
    document.head.appendChild(style)

    const ai_container = document.createElement('div')
    ai_container.id = 'ai-widget-container'
    ai_container.style.position = 'absolute'
    ai_container.style.bottom = '0px'
    ai_container.style.right = '0px'
    ai_container.style.width = '400px'
    ai_container.style.height = '500px'
    document.body.appendChild(ai_container)

    if (window.init_ai) {
      if (assistant_tag) {
        const client_key = assistant_tag.dataset.clientKey
        window.init_ai({
          element_id: '#ai-widget-container',
          client_key,
        })
      }
    }
  })
})()
